import React from 'react';
import PropTypes from 'prop-types';

function Footer({ author }) {
  return (
    <footer id='main-footer' className='bg-dark' style={{ color: '#fff' }}>
      <div className='container'>
        <div className='row'>
          <div className='col text-center pt-4'>
            <h3>
              Loop<b style={{ color: '#cd5c5c' }}>Med</b>
            </h3>
            <h5>Copyright © 2020</h5>
            <p>{author}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTupes = {
  author: PropTypes.string.isRequired
};

Footer.defaultProps = {
  author: 'Zighed Mohammed Elamine'
};

export default Footer;
